import { useState } from "react";
import axios from "axios";
import md5 from "md5";
import { toast } from "react-toastify";
import { globalGetApiUrl } from "../../../../utils/globalBaseUrl";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { PASSWORD_REQUIREMENTS, passwordSchema } from "../../../../utils/passwordPolicy";
import { generateTrackingObject, trademoTrackingEvents } from "../../../../core/utility/trademo-tracking";
import { trackingEventDictionary } from "../../../../core/dictionary/track-events";
const SecurityDetailsEditAPIEndpoints = {
  resetPassword: globalGetApiUrl("auth/resetLoginPassword"),
};
export default function ProfileDetails(props) {
  const [oldPasswordvalidation, setOldPasswordError] = useState("");
  const [incorrectoldpassword, setIncorrectPassword] = useState("");
  const handleClick = async (data) => {
    if (data.currentPassword === data.password) {
      setOldPasswordError("New password cannot be same as old password");
      setTimeout(() => {
        setOldPasswordError("");
      }, 4000);
      return false;
    }
    trademoTrackingEvents(trackingEventDictionary.headerUserProfileProfileDetailsSecurityChangePasswordResetPassword, generateTrackingObject());

    const o_pass = md5(data.currentPassword);
    const n_pass = md5(data.password);
    const payload = {
      oldPassword: o_pass,
      newPassword: n_pass,
      email: props.userDetails.email,
    };
    axios
      .post(SecurityDetailsEditAPIEndpoints.resetPassword, payload)
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        if (data.status === "success") {
          toast.success(data.status);
          props.togglefunc2();
        } else {
          setIncorrectPassword(data.message);
          setTimeout(() => {
            setIncorrectPassword("");
          }, 4000);
        }
      });
  };
  return (
    <div>
      <h4 className="mx-4 my-3 main-profile-header">Security Details</h4>
      <div className="card mx-4">
        <div className="card-header">
          <h3 className="card-title my-1">Change Password</h3>
        </div>
        <div className="card-body">
          <div className="reset-form w-50 mx-auto">
            <Formik
              initialValues={{
                currentPassword: "",
                password: "",
                confirmPassword: "",
              }}
              validationSchema={Yup.object().shape({
                currentPassword: Yup.string().required("Password is required"),
                password: passwordSchema(props.userDetails && props.userDetails.email),
                confirmPassword: Yup.string()
                  .oneOf([Yup.ref("password"), null], "Passwords must match")
                  .required("Confirm Password is required"),
              })}
              onSubmit={(values, { setSubmitting }) => {
                handleClick(values, setSubmitting);
              }}
              render={({ errors, touched }) => (
                <Form>
                  <div className="form-group">
                    <label htmlFor="currentPassword">Current Password</label>
                    <Field
                      name="currentPassword"
                      type="password"
                      placeholder="Enter Old password"
                      className={"form-control" + (errors.currentPassword && touched.currentPassword ? " is-invalid" : "")}
                    />
                    <ErrorMessage name="currentPassword" component="div" className="invalid-feedback" />
                    {!!incorrectoldpassword && incorrectoldpassword !== "" ? <div className="trademo-validation-text">{incorrectoldpassword}</div> : <div className="d-none"></div>}
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">New Password</label>
                    <Field
                      name="password"
                      type="password"
                      placeholder="Enter New password"
                      className={"form-control" + (errors.password && touched.password ? " is-invalid" : "")}
                    />
                    <ErrorMessage name="password" component="div" className="invalid-feedback" />
                    {!!oldPasswordvalidation && oldPasswordvalidation !== "" ? (
                      <div className="trademo-validation-text">{oldPasswordvalidation}</div>
                    ) : (
                      <div className="d-none"></div>
                    )}
                    <ul className="small text-muted mt-2 mb-0 pl-3">
                      {PASSWORD_REQUIREMENTS.map((req) => (
                        <li key={req}>{req}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="form-group">
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    <Field
                      name="confirmPassword"
                      type="password"
                      placeholder="Confirm password"
                      className={"form-control" + (errors.confirmPassword && touched.confirmPassword ? " is-invalid" : "")}
                    />
                    <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                  </div>
                  <div className="form-group text-right">
                    <button
                      type="button"
                      onClick={() => {
                        props.togglefunc1();
                        trademoTrackingEvents(trackingEventDictionary.headerUserProfileProfileDetailsSecurityChangePasswordCancel, generateTrackingObject());
                      }}
                      className="btn btn-outline-secondary btn-edit"
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary btn-reset ml-2">
                      Reset Password
                    </button>
                  </div>
                </Form>
              )}
            ></Formik>
          </div>
        </div>
      </div>
    </div>
  );
}
